var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-confirm-modal',{attrs:{"modal":_vm.modal,"title":_vm.$t('users.change-status.title', {
      status: _vm.item.isActive
        ? _vm.$t('defaults.text.inactive').toLowerCase()
        : _vm.$t('defaults.text.active').toLowerCase(),
    }),"text":_vm.$t('users.change-status.text', {
      status: _vm.item.isActive
        ? _vm.$t('defaults.text.inactive').toLowerCase()
        : _vm.$t('defaults.text.active').toLowerCase(),
    }),"submitButtonText":_vm.item.isActive
      ? _vm.$t('defaults.button.deactivate')
      : _vm.$t('defaults.button.activate'),"submitButtonColor":_vm.item.isActive ? 'error' : 'success',"isSubmitting":_vm.isSubmitting},on:{"submitModal":_vm.handleSubmitModal,"closeModal":_vm.handleCloseModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }